const Tiktok = (props) => (
  <svg
    viewBox="0 0 448 512"
    focusable="false"
    role="img"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M448 209.9a210.1 210.1 0 0 1-122.8-39.25V349.4A162.6 162.6 0 1 1 185 188.3v89.9a74.62 74.62 0 1 0 52.23 71.18V0h88a121.2 121.2 0 0 0 1.86 22.17A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.14z"
    ></path>
  </svg>
);
export default Tiktok;
